import React, { useState } from "react";
import { toast } from "react-toastify";
import { useLoginApi } from "../api/login.js";

import "../styles/colors.css";
import "../styles/fonts.css";
import "../styles/common.css";
import "../styles/layout.css";

import { ReactComponent as BalerLogo } from "../assets/icons/baler.svg";
import AkiraLogo from "../assets/icons/akira_no_bg_white_border.png";

import CustomTextField from "../components/CustomTextField.jsx";
import CustomButton from "../components/CustomButton.jsx";
import { validatePhoneNumber, validatePassword } from "../util/validation.js";

export default function LoginPage({ onLoginSuccess }) {
  const { encryptPassword, loginCustomer } = useLoginApi();

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  /* =====================================
     APPLY THEME BASED ON ROLE
  ===================================== */
  function applyTheme(role) {
    document.body.classList.remove("admin-theme", "manufacturer-theme");

    if (role === "admin") {
      document.body.classList.add("admin-theme");
    } else {
      document.body.classList.add("manufacturer-theme");
    }
  }

  /* =====================================
     LOGIN SUBMIT
  ===================================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePhoneNumber(mobile)) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    if (!validatePassword(password)) {
      toast.error(
        "Password must be at least 6 characters and contain at least one letter and one number"
      );
      return;
    }

    try {
      const encryptedPassword = await encryptPassword(password);

      const result = await loginCustomer({
        phoneNo: mobile,
        encryptedPassword,
      });

      if (result.success) {
        toast.success("Login successful!");

        // ✅ SAVE TOKEN
        localStorage.setItem("token", result.token);

        // ✅ SAVE ROLE
        const role = result.user?.role || "manufacturer";
        localStorage.setItem("userRole", role);

        // ✅ APPLY THEME
        applyTheme(role);

        if (onLoginSuccess) onLoginSuccess();
      } else {
        toast.error(result.message || "Login failed");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  /* =====================================
     LOGO BASED ON LAST LOGIN ROLE (OPTIONAL)
  ===================================== */
  const savedRole = localStorage.getItem("userRole");
  const isAdmin = savedRole === "admin";

  /* =====================================
     UI
  ===================================== */
  return (
    <div className="auth-wrap">
      <div className="auth-card">

        {/* LEFT PANEL */}
        <div className="auth-left">
          {isAdmin ? (
            <img src={AkiraLogo} alt="Akira" className="logo-svg" />
          ) : (
            <BalerLogo className="logo-svg" />
          )}

          <div className="brand-title">
            {isAdmin ? "AKIRA" : "JS AGRO"}
          </div>

          <div className="brand-sub">
            {isAdmin
              ? "ADMIN CONTROL PANEL"
              : "INVENTORY MANAGEMENT"}
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-right">
          <form onSubmit={handleSubmit} className="login-form">

            <CustomTextField
              label="Mobile Number"
              value={mobile}
              numericOnly
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter 10-digit mobile number"
              required
            />

            <CustomTextField
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />

            <CustomButton type="submit" className="btn-sign">
              Sign In
            </CustomButton>
          <div className="forgot-link">
            <span onClick={() => window.location.href="/forgot-password"}>
              Forgot Password?
            </span>
          </div>
          </form>
        </div>

      </div>
    </div>
  );
}